import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { TablepagedComponent, ColumnDef } from '../../../containers/table/tablepaged/tablepaged.component';
import {  FormAddConfig } from "../../../containers/form/formadd/formadd.component";
import {  FormUpdateConfig } from "../../../containers/form/formupdate/formupdate.component";
import { UpdateAddTableComponent, AttributeDefinition, InputType } from "../../basic/update-add-table/update-add-table.component";

@Component({
  selector: 'app-grouprole',
  imports: [UpdateAddTableComponent],
  templateUrl: './grouprole.component.html',
  styleUrl: './grouprole.component.scss',
})
export class GrouproleComponent {
title = 'Auth group roles';
description = "This are the group roles of the App";
path = "/auth/grouprole";
showFormAdd = true
element_name="grouprole";
showUpdateButton = true;
showDeleteButton = true;

config: Array<AttributeDefinition> = [
{ title: 'Id',               store_key: 'Id' },
{ title: 'IdUserCreation',   store_key: 'IdUserCreation', hidden: true},
{ title: 'TimeCreation',     store_key: 'TimeCreation' , hidden: true},
{ title: 'Name',             store_key: 'Name' },
{ title: 'Description',      store_key: 'Description' },
{ title: 'Group',            store_key: 'Group.Name' , type: InputType.select, options_path: "/auth/group"},
{ title: 'Role',             store_key: 'Role.Name' , type: InputType.select,  options_path: "/auth/role"}
];

@ViewChild(TablepagedComponent) table!: TablepagedComponent;

}
